import AppRoutes from './routes'
import { useSession } from './state/session'

export default function App() {
  return (
    <>
      <AppRoutes />
      <SceneStateDebugBar />
    </>
  )
}

/**
 * Dev-only debug bar that surfaces the current `sceneState` so we can watch
 * state transitions while building Phase 2. Hidden in production builds.
 */
function SceneStateDebugBar() {
  const sceneState = useSession((s) => s.sceneState)
  if (!import.meta.env.DEV) return null
  return (
    <div className="fixed bottom-0 inset-x-0 z-50 px-3 py-1.5 bg-slate-900/80 text-slate-100 text-xs font-mono flex items-center gap-2 backdrop-blur">
      <span className="opacity-60">scene:</span>
      <span className="font-semibold">{sceneState}</span>
    </div>
  )
}
